<div class="dropdown auto" [ngClass]="{ 'dropdown__fill': theme === Theme.FILL }">
  <mat-form-field class="dropdown__content">
    <p matPrefix class="dropdown__content-prefix m-0 small flex align-center">
      <app-icon *ngIf="iconName" [name]="iconName" size="xs" class="mr-1" [ngClass]="{ iconColor: iconColor }"></app-icon>
      <span class="text-nowrap">{{ dropdownText }}:</span>
    </p>

    <mat-select [value]="selectedValue" (selectionChange)="onSelectedValueChange($event)" [disabled]="disabled" class="small m-0">
      <mat-option *ngFor="let item of dropdownValue" [value]="item.value" class="option-container">
        <ng-container class="dropdown__content__value p-0 small">
          {{ (labelTranslationKey.length ? labelTranslationKey + '.' : '') + item.displayName | translate }}
        </ng-container>
      </mat-option>
    </mat-select>

    <app-spinner matSuffix *ngIf="isLoading" [small]="true"></app-spinner>
  </mat-form-field>
</div>
